import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from "@angular/common/http";

import { SeguridadRoutingModule } from "./seguridad-routing.module"
import { PermisosComponent } from './permisos/permisos.component';
import { ComponentesModule } from "../componentes/componentes.module";

import {PanelMenuModule} from 'primeng/panelmenu';

@NgModule({
  declarations: [PermisosComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    SeguridadRoutingModule,
    ComponentesModule,
    PanelMenuModule,
  ]
})
export class SeguridadModule { }
